import { useIntlayer } from 'react-intlayer';

import {
  BulletListSection,
  ChangesSection,
  DataSharingSection,
  DPOSection,
  LawfulBasisSection,
  PrivacyHeader,
  SectionWithText,
  YourRightsSection,
} from './PrivacySections';

import { CTASection } from '~/components/landing/CTASection';

export const PrivacyPolicyPage = () => {
  const content = useIntlayer('privacy');

  return (
    <div className="relative min-h-screen bg-black text-white">
      {/* Main Content */}
      <div className="pt-40 md:pt-48 pb-80 px-4 md:px-8 lg:px-20">
        <div className="max-w-7xl mx-auto flex flex-col gap-14 md:gap-20">
          <PrivacyHeader date={content.date} title={content.title} />

          {/* Content - Offset to the right on desktop */}
          <div className="md:pl-[27rem] md:pr-28 flex flex-col gap-7 md:gap-10 text-white">
            <SectionWithText
              title={content.scopeAndOverview.title}
              text={content.scopeAndOverview.text}
            />

            <LawfulBasisSection
              title={content.lawfulBasis.title}
              intro={content.lawfulBasis.intro}
              items={content.lawfulBasis.items}
            />

            <DataSharingSection
              title={content.dataSharing.title}
              intro={content.dataSharing.intro}
              items={content.dataSharing.items}
              conclusion={content.dataSharing.conclusion}
            />

            <BulletListSection
              title={content.securityAndControl.title}
              items={content.securityAndControl.items}
            />

            <SectionWithText
              title={content.dataRetention.title}
              text={content.dataRetention.text}
            />

            <YourRightsSection
              title={content.yourRights.title}
              intro={content.yourRights.intro}
              rights={content.yourRights.rights}
              requestsText={content.yourRights.requestsText}
            />

            <DPOSection
              title={content.dpo.title}
              contact={content.dpo.contact}
              complaint={content.dpo.complaint}
              orByCall={content.dpo.orByCall}
            />

            <ChangesSection
              title={content.changes.title}
              text={content.changes.text}
              effective={content.changes.effective}
            />
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
};
